export enum Modules {
    Resources = 'Resources',
    Maintenance = 'Maintenance',
    Operations = 'Operations',
    GPS = 'GPS',
    RentCars = 'RentCars',
    Reports = 'Reports',
    Schools = 'Schools'
}